import { useQuery } from "@tanstack/react-query";

/**
 * Returns the version of the SPA.
 * Used to check if prompt to update should show.
 * @returns
 */
export function useSpaVersion() {
	return useQuery<{ gitVersion: string }>(
		["spa", "version"],
		() =>
			fetch("/version")
				.then((res) => res.json())
				.catch(() => ""),
		{
			refetchInterval: 60 * 1000 * 5,
		}
	);
}
